export default __webpack_public_path__ + "static/media/subtract.6bf2884b.png";